import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { CamelCaseToFirstUpper } from "../../../Components/Functions/word.fun";
import { BsArrowRightCircleFill } from "react-icons/bs";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";

const getHeartButtonWithUserId = (
  filters,
  favWiki,
  userId,
  Wiki,
  addToFavorite,
  removeFromFavorite
) => {
  let checkFav = [];
  if (!Wiki.favouriteOnly) {
    checkFav = favWiki.filter((item) => {
      if (item.favId == Wiki.id && item.userId == userId) {
        return true;
      }
    });
  }
  if (Wiki.userId && Wiki.userId == userId) {
    checkFav.push(Wiki);
  }

  if (checkFav && checkFav.length > 0) {
    return (
      <FaHeart
        className="text-danger"
        style={{ cursor: "pointer", fontSize: "1.4rem" }}
        onClick={(e) => removeFromFavorite(e, Wiki, favWiki, userId)}
      />
    );
  } else {
    return (
      <FaRegHeart
        className="text-muted"
        style={{ cursor: "pointer", fontSize: "1.4rem" }}
        onClick={(e) => addToFavorite(e, Wiki, userId)}
      />
    );
  }
};

const clampStyle = {
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 2,
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const AgronomyWikiTable = ({
  Wikis,
  favWiki,
  userId,
  refresh,
  setRefresh,
  filters,
}) => {
  const navigate = useNavigate();
  const store = useSelector((store) => store.login.user);
  const [id, setId] = useState();
  const [themeSet, setThemeSet] = useState("");
  const [searchParams] = useSearchParams();
  const theme = searchParams.get("theme");

  const [checkClientAccess, setCheckClientAccess] = useState({
    workOrder: false,
    isHandOverCompleted: false,
    isClient: store?.Role == process.env.REACT_APP_ROLE_CLIENT,
  });
  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/projectTracking/getProjectTracking", 1)
    )
      .then((res) => {
        if (res.status === 200) {
          let access = {
            isHandOverCompleted: false,
            workOrder: false,
            isClient: false,
          };

          if (res?.data?.clientHandover?.handOverCertificate) {
            access.isHandOverCompleted = true;
          }
          if (res?.data?.projectTrackingData?.[0]?.workOrderUpload) {
            access.workOrder = true;
          }
          if (store?.Role == process.env.REACT_APP_ROLE_CLIENT) {
            access.isClient = true;
          }
          setCheckClientAccess(access);
        } else {
          Toast("error", "Error while getting Leads!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);
  const navigateTocreateBatch = () => {
    if (
      checkClientAccess?.isClient &&
      !checkClientAccess?.isHandOverCompleted
    ) {
      Toast(
        "error",
        "Your handover process is not yet complete, so you cannot create a new nursery batch at this time. Please contact the Kryzen support team for further details."
      );
    } else {
      navigate("/farm-nursery-management/new-batch");
    }
  };

  const addToFavorite = async (event, Wiki, userId) => {
    event.stopPropagation();
    const values = {
      ...Wiki,
      userId: userId,
      favId: Wiki.id,
    };
    try {
      const res = await performRequest(
        "POST",
        `/favouriteWiki/createFavoriteWiki`,
        values
      );
      if (res.status === 201) {
        Toast("success", "Favorite status updated!");
        setRefresh(!refresh);
      } else {
        Toast("error", "Error while updating favorite status");
      }
    } catch (err) {
      // Toast("error", "Server Error!");
      // console.error(err);
      CustomErrorResponse(err);
    }
  };
  const removeFromFavorite = async (event, Wiki, favWiki, userId) => {
    event.stopPropagation();

    let favId = "";
    if (!Wiki.favouriteOnly) {
      favWiki.filter((item) => {
        if (item.favId == Wiki.id && item.userId == userId) {
          favId = item.id;
        }
      });
    }
    if (Wiki.userId && Wiki.userId == userId) {
      favId = Wiki.id;
    }

    if (favId) {
      try {
        const res = await performRequest(
          "DELETE",
          `/favouriteWiki/removeFavouriteWiki/${favId}`
        );

        if (res.status === 200) {
          Toast("success", "Removed from favorites!");
          setRefresh(!refresh);
        } else {
          Toast("error", "Error while updating favorite status");
        }
      } catch (err) {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      }
    }
  };
  const handleCardClick = (Wiki) => {
    if (Wiki.favouriteOnly == false) {
      navigate(`/agronomy-plants-wiki/view/${Wiki.id}`);
    } else {
      navigate(`/agronomy-plants-wiki/view/${Wiki.favId}/?favorite=true`);
    }
  };

  useEffect(() => {
    setThemeSet(theme);
  }, [theme]);

  return (
    <>
      <div class="table-responsive">
        <table class="table table-vcenter card-table table-striped">
          <thead>
            <tr>
              <th>Fav</th>
              <th>Plant Name</th>
              <th className="w-33 d-none d-md-table-cell">Description</th>
              <th>Start Batch</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {Wikis?.map((wiki) => (
              <tr key={wiki?.id}>
                <td className="border">
                  {getHeartButtonWithUserId(
                    filters,
                    favWiki,
                    userId,
                    wiki,
                    addToFavorite,
                    removeFromFavorite
                  )}
                </td>
                <td>
                  <div className="row">
                    <div className="col-md-2">
                      <img src={wiki?.image} alt="Plant" width="40" />
                      {/* <div
                        className="avatar img-fluid"
                        style={{ backgroundImage: `url(${wiki?.image})` }}
                      ></div> */}
                    </div>
                    <div className="col-auto">
                      {wiki?.name?.toUpperCase()} <br />
                      <span className="text-secondary">
                        {CamelCaseToFirstUpper(wiki?.articleType)}
                      </span>
                    </div>
                  </div>
                </td>
                <td className="d-none d-md-table-cell">
                  <p
                    className={` m-0 ${
                      themeSet === "dark" ? "text-light" : "text-muted"
                    }`}
                    style={clampStyle}
                  >
                    {wiki?.description}
                  </p>
                </td>
                <td>
                  <button
                    className="btn btn-success btn-sm px-3 "
                    onClick={(e) => {
                      e.stopPropagation();
                      setId(wiki.id);
                      navigateTocreateBatch();
                    }}
                  >
                    Start Batch
                  </button>
                </td>
                <td>
                  {/* <button
                    className="btn btn-primary"
                    onClick={() => handleCardClick(wiki)}
                  >
                    <BsArrowRightCircleFill />
                  </button> */}
                  <CustomViewButton
                    onClick={() => handleCardClick(wiki)}
                  ></CustomViewButton>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default AgronomyWikiTable;
